import {owns} from '@republic/foundation/lang/object'
import {createMethod, createModel, on} from '@republic/foundation/streams/models'

const
    show = createMethod(name => ({name})),
    hide = createMethod(name => ({name})),
    methods = {show, hide}

export default (
    createModel(
        {},
        on(show.stream, (modals, {name}) => (
            !owns(modals, name) ?
                {
                    ...modals,
                    [name]: true
                } :
                modals)),
        on(hide.stream, (modals, {name}) => (
            owns(modals, name) ?
                (({[name]: modal, ...modals}) => modals)(modals) :
                modals))))

export {methods}
